// import React, { useState, useEffect } from "react";
// import { useHistory } from "react-router-dom";
// import "./../App.css";
// import { toast } from "react-toastify";
// import { AdminService } from "../services";
// import { Routes } from "../constants";
// import { injectModels } from "../redux/injectModels";
// import { Circles } from "react-loader-spinner";

// const StripeCheckout = () => {
//   const history = useHistory();

//   const [plan, setPlan] = useState("monthly");
//   const [termsAccepted, setTermsAccepted] = useState(false);
//   const userId = localStorage.getItem("user_id");
//   const [loading, setLoading] = useState(false);

//   const handleCheckout = async () => {
//     if (!termsAccepted) {
//       toast.error("Please accept Terms & Conditions");
//       return;
//     }

//     try {
//       setLoading(true);

//       const payload = {
//         uid: userId,
//         plan: plan,
//       };

//       const res = await AdminService.createSubscription(payload);

//       if (res.sessionUrl) {
//         // Stripe redirect – loader rehne do
//         window.location.href = res.sessionUrl;
//       } else {
//         setLoading(false);
//         toast.error("Unable to create checkout session");
//       }
//     } catch (err) {
//       setLoading(false);
//       toast.error("Unable to proceed to checkout");
//     }
//   };

//   useEffect(() => {
//     setLoading(true);

//     // thoda delay taaki blank flash na aaye
//     const timer = setTimeout(() => {
//       setLoading(false);
//     }, 500);

//     return () => clearTimeout(timer);
//   }, []);

//   return (
//     <>
//       {loading && (
//         <div className="spinner">
//           <div className="loader">
//             <Circles
//               height="110"
//               width="110"
//               color="#FFF"
//               ariaLabel="circles-loading"
//               visible={true}
//             />
//           </div>
//         </div>
//       )}

//       <section className="premium-checkout">
//         <div className="container">
//           <div className="month-subscrption">
//             <span
//               onClick={() => history.push(Routes.BUY_SUBSCRIPTION)}
//               className="back-link"
//             >
//               <i className="fa-solid fa-arrow-left"></i> Back
//             </span>

//             <h2 className="uph2 mb-4">Choose your plan</h2>

//             <div className="plan-tiles">
//               <div
//                 className={`plan-tile ${plan === "monthly" ? "active" : ""}`}
//                 onClick={() => setPlan("monthly")}
//               >
//                 <i className="fa-solid fa-calendar"></i>
//                 <span>Monthly</span>
//               </div>

//               <div
//                 className={`plan-tile ${plan === "annual" ? "active" : ""}`}
//                 onClick={() => setPlan("annual")}
//               >
//                 <i className="fa-solid fa-calendar-check"></i>
//                 <span>Annual</span>
//               </div>
//             </div>

//             <div className="mt-3">
//               <label className="terms-checkbox">
//                 <input
//                   type="checkbox"
//                   checked={termsAccepted}
//                   onChange={() => setTermsAccepted(!termsAccepted)}
//                 />
//                 I agree to the{" "}
//                 <a
//                   href="https://gewardzhealth.com/terms-of-service"
//                   target="_blank"
//                   rel="noreferrer"
//                 >
//                   Terms & Conditions
//                 </a>
//               </label>
//             </div>

//             <button
//               className="org-big-btn btn-bx-shadow w-100 mt-3"
//               onClick={handleCheckout}
//             >
//               Proceed to payment
//             </button>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default injectModels(["auth"])(StripeCheckout);

import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import "./../App.css";
import { toast } from "react-toastify";
import { AdminService } from "../services";
import { Routes } from "../constants";
import { injectModels } from "../redux/injectModels";
import { Circles } from "react-loader-spinner";

const StripeCheckout = () => {
  const history = useHistory();

  const [plan, setPlan] = useState("monthly");
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [minimumAccepted, setMinimumAccepted] = useState(false);
  const userId = localStorage.getItem("user_id");
  const [loading, setLoading] = useState(false);

  const handleCheckout = async () => {
    if (!termsAccepted) {
      toast.error("Please accept Terms & Conditions");
      return;
    }

    if (!minimumAccepted) {
      toast.error("Please agree to subscribe for a minimum of 6 months");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        uid: userId,
        plan: plan,
        min_term_agreed_at: true,
      };

      const res = await AdminService.createSubscription(payload);

      if (res.sessionUrl) {
        // Stripe redirect – loader rehne do
        window.location.href = res.sessionUrl;
      } else {
        setLoading(false);
        toast.error("Unable to create checkout session");
      }
    } catch (err) {
      setLoading(false);
      toast.error("Unable to proceed to checkout");
    }
  };

  useEffect(() => {
    setLoading(true);

    // thoda delay taaki blank flash na aaye
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {loading && (
        <div className="spinner">
          <div className="loader">
            <Circles
              height="110"
              width="110"
              color="#FFF"
              ariaLabel="circles-loading"
              visible={true}
            />
          </div>
        </div>
      )}

      <section className="premium-checkout">
        <div className="container">
          <div className="month-subscrption">
            <span
              onClick={() => history.push(Routes.BUY_SUBSCRIPTION)}
              className="back-link"
            >
              <i className="fa-solid fa-arrow-left"></i> Back
            </span>

            <h2 className="uph2 mb-4">Choose your plan</h2>

            <div className="plan-tiles">
              <div
                className={`plan-tile ${plan === "monthly" ? "active" : ""}`}
                onClick={() => setPlan("monthly")}
              >
                <i className="fa-solid fa-calendar"></i>
                <span>Monthly</span>
                <div className="plan-price">24.99</div>
              </div>

              <div
                className={`plan-tile ${plan === "annual" ? "active" : ""}`}
                onClick={() => setPlan("annual")}
              >
                <i className="fa-solid fa-calendar-check"></i>
                <span>Annual</span>
                <div className="plan-price">269</div>
              </div>
            </div>

            <div className="mt-3">
              <label className="terms-checkbox">
                <input
                  type="checkbox"
                  checked={termsAccepted}
                  onChange={() => setTermsAccepted(!termsAccepted)}
                />
                I agree to the{" "}
                <a
                  href="https://gewardzhealth.com/terms-of-service"
                  target="_blank"
                  rel="noreferrer"
                >
                  Terms & Conditions
                </a>
              </label>
            </div>

            <div className="mt-2">
              <label className="terms-checkbox">
                <input
                  type="checkbox"
                  checked={minimumAccepted}
                  onChange={() => setMinimumAccepted(!minimumAccepted)}
                />
                I agree to subscribe for a minimum of 6 months
              </label>
            </div>

            <button
              className="org-big-btn btn-bx-shadow w-100 mt-3"
              onClick={handleCheckout}
            >
              Proceed to payment
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default injectModels(["auth"])(StripeCheckout);